export interface LegacySystemFeeOffice {
  id: number
  type: string
  name: string
  program: number
  storage: number
  sms: number
  lms: number
  mms: number
}

export const legacySystemFeeOffices: LegacySystemFeeOffice[] = Array.from({ length: 32 }, (_, index) => ({
  id: index + 1,
  type: index % 2 === 0 ? 'Mock 가맹' : 'Mock 직영',
  name: `Mock 지점 ${String(index + 1).padStart(2, '0')}`,
  program: 100000,
  storage: 100,
  sms: 20,
  lms: 40,
  mms: 80,
}))
